import React from 'react';
import styles from './Hero.module.css';

function Hero() {
  const backgroundUrl = process.env.PUBLIC_URL + '/images/hero%20background.png';

  return (
    <header
      className={styles.hero}
      style={{ backgroundImage: `url("${backgroundUrl}")` }}
      aria-label="Hero section"
    >
      <div className={styles.overlay} />

      <div className={`container ${styles.content}`}>
        <div className={styles.ctaRow}>
          <div className={styles.headline}>Together, we transform today’s operations from the ground up to future AI airport</div>
          <div className={styles.subheadline}>
          Trusted by the world’s largest ground handler in Asia to lead AI-transformation at Singapore Changi Airport
          </div>
           <div className={styles.buttons}>
             <button className={styles.btnPrimary} onClick={() => {
               const contactSection = document.getElementById('contact');
               if (contactSection) {
                 contactSection.scrollIntoView({ behavior: 'smooth' });
               }
             }}>Request a Demo</button>
             <button className={styles.btnContact} onClick={() => {
               const contactForm = document.getElementById('contact-us-form');
               if (contactForm) {
                 contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
               } else {
                 const contactSection = document.getElementById('contact');
                 if (contactSection) {
                   contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                 } else {
                   window.location.href = '/#contact';
                 }
               }
             }}>Contact Us</button>
           </div>
        </div>
      </div>
    </header>
  );
}

export default Hero;


